import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=0740ba0b&scoped=true&"
import script from "./Tag.vue?vue&type=script&lang=ts&"
export * from "./Tag.vue?vue&type=script&lang=ts&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=0740ba0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740ba0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0740ba0b', component.options)
    } else {
      api.reload('0740ba0b', component.options)
    }
    module.hot.accept("./Tag.vue?vue&type=template&id=0740ba0b&scoped=true&", function () {
      api.rerender('0740ba0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TagBluetooth/Tag.vue"
export default component.exports